import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "services/analytics";

export default function TrackPageViews() {
  const location = useLocation();

  useEffect(() => {
    const handleTitleUpdate = () => {
      setTimeout(() => {
        analytics.page(document.title || "Unknown Page", {
          hash: location.hash ?? "",
        });
      }, 0);
    };

    handleTitleUpdate();
  }, [location]);

  return null;
}
